"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DynamicButton_1 = __importDefault(require("../containers/DynamicButton"));
const DynamicDisplay_1 = __importDefault(require("../containers/DynamicDisplay"));
const DynamicField_1 = __importDefault(require("../containers/DynamicField"));
const DynamicFusion_1 = __importDefault(require("../containers/DynamicFusion"));
const Repeat = ({ label, inputs, fusions, renderers = {}, enableRulesets, passthroughProps, indent = 0, formId, formIndex, RepeatGroupWrapper, RepeatItemWrapper, dispatchers, }) => (react_1.default.createElement(RepeatGroupWrapper, { label: label, inputs: inputs, passthroughProps: passthroughProps, indent: indent }, inputs.map((repeatInputs, sectionIndex) => (react_1.default.createElement(RepeatItemWrapper, { key: sectionIndex, inputs: repeatInputs, passthroughProps: passthroughProps, indent: indent }, repeatInputs.map(({ type, label: fieldLabel, indent: fieldIndent = 0, id, fusion, ...input }, index) => {
    const props = {
        ...input,
        type,
        label: fieldLabel,
        indent: indent + fieldIndent,
        id,
        key: id || `${fieldLabel}_${index}`,
        formId,
        formIndex,
        enableRulesets,
        passthroughProps,
    };
    if (type === 'group' && fusion && fusions[fusion]) {
        return (react_1.default.createElement(DynamicFusion_1.default, { ...props, dispatchers: dispatchers, component: fusions[fusion] }));
    }
    if (type === 'group') {
        return inputs.map(({ type: subType, label: subFieldLabel, indent: subFieldIndent = 0, id: subId, ...subInput }, subIndex) => {
            const subProps = {
                ...subInput,
                type: subType,
                label: subFieldLabel,
                id: subId,
                formId,
                formIndex,
                indent: indent + fieldIndent + subFieldIndent,
                key: id || `${fieldLabel}_${subIndex}`,
                enableRulesets,
                passthroughProps,
            };
            const subComponent = renderers[type];
            if (!subComponent) {
                const Fallback = renderers.fallback;
                return react_1.default.createElement(Fallback, { ...subProps });
            }
            if (type === 'button' || type === 'submit') {
                return (react_1.default.createElement(DynamicButton_1.default, { ...subProps, component: component, dispatchers: dispatchers }));
            }
            if (type === 'output') {
                return react_1.default.createElement(DynamicDisplay_1.default, { ...subProps, component: component });
            }
            return react_1.default.createElement(DynamicField_1.default, { ...subProps, component: component });
        });
    }
    const component = renderers[type];
    if (!component) {
        const Fallback = renderers.fallback;
        return react_1.default.createElement(Fallback, { ...props });
    }
    if (type === 'button' || type === 'submit') {
        return react_1.default.createElement(DynamicButton_1.default, { ...props, component: component, dispatchers: dispatchers });
    }
    if (type === 'output') {
        return react_1.default.createElement(DynamicDisplay_1.default, { ...props, component: component });
    }
    return react_1.default.createElement(DynamicField_1.default, { ...props, component: component });
}))))));
exports.default = Repeat;
//# sourceMappingURL=Repeat.js.map